var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#1D2933",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5118 0.488155C16.861 -0.162718 15.8057 -0.162718 15.1548 0.488155L0.488155 15.1548C-0.162719 15.8057 -0.162719 16.861 0.488155 17.5118C1.13903 18.1627 2.1943 18.1627 2.84518 17.5118L17.5118 2.84518C18.1627 2.1943 18.1627 1.13903 17.5118 0.488155Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.488155 0.488155C1.13903 -0.162718 2.1943 -0.162718 2.84518 0.488155L17.5118 15.1548C18.1627 15.8057 18.1627 16.861 17.5118 17.5118C16.861 18.1627 15.8057 18.1627 15.1548 17.5118L0.488155 2.84518C-0.162718 2.1943 -0.162718 1.13903 0.488155 0.488155Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalXIcon);
export default __webpack_public_path__ + "static/media/modal-X-icon.8ec4507ff20d087214a850cf9d7d0db7.svg";
export { ForwardRef as ReactComponent };